<template>
    <div>
        <h2>{{ $t("wp.activationPageHeading") }}</h2>
        <h4>{{ $t("wp.waitForWpActivationDescription") }}</h4>
        <div class="mt-5">
            <div v-if="activating" class="d-flex flex-column justify-content-center align-items-center">
                <strong>{{ $t("wp.activatingShortStatus") }}</strong>
                <md-progress-spinner
                    class="md-accent text-danger"
                    :md-diameter="70"
                    md-mode="indeterminate"
                ></md-progress-spinner>
            </div>
            <div v-else>
                <a-result :title="$t('wp.greatWpActivatedDescription')">
                    <template #icon>
                        <a-icon type="check-circle" />
                    </template>
                    <template #extra></template>
                </a-result>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "Activation",
    data() {
        return {
            activating: true,
        };
    },
    props: {
        activated: {
            type: Function,
            default: () => {},
        },
    },
    computed: {
        ...mapState({
            settings: (state) => state.setting.settings,
            isSettingInitialized: (state) => state.setting.initialized,
            site: (state) => state.site.site,
            initialized: (state) => state.whatsapp.info?.initialized,
            status: (state) => state.whatsapp.info.status,
        }),
    },
    mounted() {
        if (this.initialized && this.status?.created) {
            this.activating = false;
            this.activated();
        }
    },
    watch: {
        status(val) {
            console.log("Activation status..", val);
            if (val.created) {
                this.activating = false;
                this.activated();
            }
        },
    },
};
</script>

<style scoped></style>
